module.exports = __webpack_public_path__ + "img/logo-cmc-white.20cd5d7f.svg";